module.exports = __webpack_public_path__ + "static/media/briefcase.25adb704.svg";